<div *ngIf="!isNew else newUserTemplate" class="notification-container">
  <!-- Notification List -->
  <div class="notification-list">
    <div *ngFor="let notification of notifications" [id]="notification.notificationId" class="notification-item">
      <div class="d-flex align-items-start">
        <div class="w-100">
          <div class="position-relative">
            <div class="">
              <!-- Top-right buttons for Edit and Delete -->
              <div class="position-absolute top-0 end-0 d-flex">
                <div>
                  <a *ngIf="notification.xCords != 0 && notification.yCords != 0"
                     class="btn btn-sm cursor-pointer text-primary border-0"
                     (click)="highlightPin(notification.notificationId)">
                    Show pin
                  </a>
                </div>

                <div *ngIf="notification.userInfo.username == user?.username" class="ms-2">
                  <a class=" btn btn-sm cursor-pointer text-primary border-0"
                     (click)="editNotification(notification.notificationId!)">
                    Edit
                  </a>
                  <a class="btn btn-sm cursor-pointer text-danger border-0"
                     (click)="deleteNotification(notification.notificationId!, blockId)">
                    Delete
                  </a>
                </div>

              </div>
              <!-- Notification user and date -->
              <div class="mb-2">
                <div>{{ notification.userInfo.name }}</div>
                <div class="small">
                  {{ notification.modifiedDate | date : "dd-MM-yyyy HH:mm" }}
                </div>
              </div>
            </div>
          </div>

          <p class="mb-1">{{ notification.notificationText }}</p>
          <a href="#" class="small text-decoration-none cursor-pointer mb-2"
             (click)="toggleReplyInput($event, notification.notificationId)">Reply</a>
          <div *ngIf="onReplyNotificationId == notification.notificationId">
            <textarea [(ngModel)]="newReplyText" class="form-control notification-text-input"
                      placeholder="Write your reply..."></textarea>

            <a *ngIf="newReplyText" href="#" class="small text-decoration-none"
               (click)="addReply($event, notification.notificationId ?? '')">Submit Reply</a>
          </div>

          <div *ngIf="editingNotificationId === notification.notificationId">
            <textarea [(ngModel)]="updatedNotificationText" class="notification-text-input form-control mt-2"
                      placeholder="Update notification text..."></textarea>
            <a class="small mt-2 text-decoration-none cursor-pointer"
               (click)="updateNotification($event, notification.notificationId!)">
              Update Notification
            </a>
          </div>

          <div *ngIf="notification.replys && notification.replys?.length != 0">
            <div *ngFor="let reply of notification.replys" class="notification-item position-relative">
              <a *ngIf="reply.userInfo?.username == user?.username"
                 class="btn btn-sm position-absolute top-0 end-0 p-2 mr-1 cursor-pointer text-danger border-0" (click)="
                  deleteReply(notification.notificationId!, reply.replyId!)
                ">x</a>

              <div class="notification-reply small">
                <div class="flex flex-column">
                  <span>{{ reply.userInfo.name }}</span><span> {{ reply.modifiedDate | date : "dd-MM-yyyy HH:mm" }}</span>
                </div>
                <strong>Reply: </strong>
                <p class="ml-2">{{ reply.replyText }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Comment Input -->
  <div>
    <textarea [(ngModel)]="newCommentText" class="notification-text-input" placeholder="Write a comment..."></textarea>
    <div class="mt-2 text-end">
      <button class="btn btn-primary" (click)="sendComment($event)" type="button">Send</button>
    </div>
  </div>
</div>
<ng-template #newUserTemplate>
  <div class="notification-container font-light">
    <i>Comments will be available after the template is created!</i>
  </div>
</ng-template>
